import React, { Component } from "react";
import "../css/Publication.css";

import Oct22 from "../Images/coverpictures/oct22.jpeg";
import July22 from "../Images/coverpictures/july22.png";
import June22 from "../Images/coverpictures/june22.jpeg";
import April22 from "../Images/coverpictures/april22.jpeg";
import Feb22 from "../Images/coverpictures/feb22.png";
import Jan22 from "../Images/coverpictures/jan22.png";
import Winter21 from "../Images/coverpictures/winter21.jpeg";
import Oct21 from "../Images/coverpictures/oct21.png";
import Sept21 from "../Images/coverpictures/sept21.png";
import Aug21 from "../Images/coverpictures/aug21.png";
import July21 from "../Images/coverpictures/july21.png";
import June21 from "../Images/coverpictures/june21.png";

import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, set } from "firebase/database";
const firebaseConfig = {
  apiKey: "AIzaSyDRwsN33ITcVFGEA0Ee70LEoxYS1_1xTbc",
  authDomain: "https://innominate-fa39e-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "innominate-fa39e",
  storageBucket: "innominate-fa39e.appspot.com",
  messagingSenderId: "864417595102",
  appId: "1:864417595102:web:151a81105d5a9e7f214c4f",
  databaseURL: "https://innominate-fa39e-default-rtdb.asia-southeast1.firebasedatabase.app"
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

class Publication extends Component {

  componentDidMount() {
    window.scrollTo(0, 0)
    this.getCount(this.state.editions[this.props.edition].editionView)
  }

  state = {
    editions: [
      {
        editionName: "June Edition '21",
        editionDate: "June 26, 2021",
        editionDescription: "This month we bring to you something new, a concept not very common when it comes to newsletters.We present to you Play- Sic the official monthly playlist from Innominate.",
        editionCover: June21,
        editionLink: "https://online.fliphtml5.com/mifgj/mtxg/",
        editionView: "june21",
        views: 1,
      },
      {
        editionName: "July Edition '21",
        editionDate: "July 20, 2021",
        editionDescription: "This month we introduce a new section, 'Controversion'. From assessing the political situation of India to admiring the likes of Monika Seles, dive deep into this month's edition. Happy Reading!",
        editionCover: July21,
        editionLink: "https://online.fliphtml5.com/mifgj/fbhp/",
        editionView: "july21",
        views: 1,
      },
      {
        editionName: "August Edition '21",
        editionDate: "August 26, 2021",
        editionDescription: "This month we, team Innominate have broadened our horizon and take a deeper dive to cover the best content, customized to make it as user-friendly so that you, can enjoy reading!",
        editionCover: Aug21,
        editionLink: "https://www.flipsnack.com/innominate/innominate-newsletter-4th-issue.html",
        editionView: "aug21",
        views: 1,
      },
      {
        editionName: "September Edition '21",
        editionDate: "September 15, 2021",
        editionDescription: "This month we dive into the foreign relations between China and Afghanistan, review the 'Maddest Transfer Market' in the football world and much more.",
        editionCover: Sept21,
        editionLink: "https://online.fliphtml5.com/mifgj/gdwe/",
        editionView: "sept21",
        views: 1,
      },
      {
        editionName: "October Edition '21",
        editionDate: "October 31, 2021",
        editionDescription: "This month we review and analyze the development of affairs in the world of sports, take an opinion on the political polarization of India and like every month we present 'Taylor Swift' in our 'Play-Sic'.",
        editionCover: Oct21,
        editionLink: "https://online.fliphtml5.com/mifgj/cowe/",
        editionView: "oct21",
        views: 1,
      },
      {
        editionName: "Winter Edition '21",
        editionDate: "December 28, 2021",
        editionDescription: "This festive season, we wish you a Merry Christmas & Happy New Year as with smiling faces we present to you, the much awaited and enthused - Winter Edition'21!",
        editionCover: Winter21,
        editionLink: "https://online.fliphtml5.com/mifgj/myme/#p=1",
        editionView: "winter21",
        views: 1,
      },
      {
        editionName: "January Edition '22",
        editionDate: "January 25, 2022",
        editionDescription: "From Mahatma Gandhi's relevance to the Bootstrap Paradox, Innominate presents to you the January Edition '22 with the best content customized to your satisfaction.",
        editionCover: Jan22,
        editionLink: "https://www.flipsnack.com/innominate/innominate-newsletter-january-edition-22-um0dimnd1j.html",
        editionView: "jan22",
        views: 1,
      },
      {
        editionName: "February Edition '22",
        editionDate: "February 12, 2022",
        editionDescription: "In the past month, the world has been subjected to a roller coaster ride when it comes to lifestyle and emotions. Starting from Biden's hot mic catch to the Ukraine invasion threat, we've been through it all. But now to cover it all up in one edition, Innominate presents to you the February Edition'22. From the first black footballer to a review of the 'Alchemist' from our newly formed partner",
        editionDescription2: ", we've got it all for you. Happy Reading!",
        editionCover: Feb22,
        bookIstaLink: "https://bookistareview.wixsite.com/website",
        editionLink: " https://www.flipsnack.com/innominate/innominate-newsletter-february-edition-22.html",
        editionView: "feb22",
        views: 1,
      },
      {
        editionName: "April Edition '22",
        editionDate: "April 04, 2022",
        editionDescription: "In light of the present war-torn situation, Innominate resorts to its roots as we base our April Edition'22 on p2, 'Protest & Peace'. From assessing the nuclear situation in Ukraine to our featured artuous. Every little bit of this edition has been crafted with the utmost care, precision, and most importantly, love. So start listening to the new Play-Sic, sign up on the volunteer forms, and dive into reading this edition. Happy Reading!",
        editionCover: April22,
        editionLink: "https://www.flipsnack.com/innominate/innominate-newsletter-april-edition-22.html",
        editionView: "april22",
        views: 1,
      },
      {
        editionName: "June Edition '22",
        editionDate: "June 15, 2022",
        editionDescription: "Team Innominate is back! We present to you the June Edition’22 based on the topic of US abortion laws. This month we take a venture out to explore the technicalities involved with abortion in the US starting from the history to analysing the implications of changes. Dive deep in to know more!",
        editionCover: June22,
        editionLink: "https://www.flipsnack.com/innominate/innominate-june-edition-22.html",
        editionView: "june22",
        views: 1,
      },
      {
        editionName: "July Edition '22",
        editionDate: "July 30, 2022",
        editionDescription: "Here's Innominate completing a whole year of interesting editions with an exclusive Issue this month, 'Middle Eastern Nights'. This month we take a tour of the brighter side of the Middle Eastern region, the side which we often forget to talk or think about. Read ahead to enjoy every bit of your journey!",
        editionCover: July22,
        editionLink: "https://www.flipsnack.com/innominate/innominate-july-edition-22.html",
        editionView: "july22",
        views: 1,
      },
      {
        editionName: "October Edition '22",
        editionDate: "October 31, 2022",
        editionDescription: "It has indeed been quite some time since our last edition. So here’s bringing to you, the best of our works till date. This month, we explore the Gandhi Family on occasion of Congress Party elections, accompanied by an Indian themed backdrop. Read on!",
        editionCover: Oct22,
        editionLink: "https://www.flipsnack.com/innominate/october-edition-22.html",
        editionView: "oct22",
        views: 1,
      },
    ]
  }

  getCount = (month) => {
    let viewsRef = ref(database, "viewsMaster/" + month + "/views");
    let setRef = ref(database, "viewsMaster/" + month);
    let data;
    let viewPromise = new Promise(function (resolve, reject) {
      onValue(viewsRef, (snapshot) => {
        data = snapshot.val();
      }, { onlyOnce: true })
      setTimeout(() => resolve(data), 1000)
    })
    viewPromise.then((data) => {
      if (data === null)
        return
      else {
        set(setRef, { views: ++data });
        this.setState(prevState => {
          let eds = Object.assign({}, prevState.editions);
          eds[this.props.edition].views = data;
          return { eds }
        })
      }
    })
  }

  render() {
    return (
      <React.Fragment>
        {/* {window.onload = this.getCount(this.state.editions[this.props.edition].editionView)} */}
        {/* {this.getCount(this.state.editions[this.props.edition].editionView)} */}
        <div className="master-container">
          <div className="container-pub" id="container-pub">
            <div className="pre-text">
              <h2 className="ed-name">{this.state.editions[this.props.edition].editionName}</h2>
              <h6 className="date">{this.state.editions[this.props.edition].editionDate}</h6>
              <h6 className="date reads">views: <span>{this.state.editions[this.props.edition].views}</span> </h6>
              <div className="hr-div">
                <hr />
              </div> <br /><br />{this.renderIntro()}<br /><br />
            </div>
            <div className="img-div">
              <a href={this.state.editions[this.props.edition].editionLink} target="_blank" rel="noopener noreferrer"
                className="img-link"><img src={this.state.editions[this.props.edition].editionCover} alt="" className="img" /></a>
            </div>
            <div className="click">
              <hr />
              <h4>Click on the Image to read it now!</h4>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderIntro() {
    if (this.props.edition === 7) {
      return (
        <p className="intro">{this.state.editions[this.props.edition].editionDescription} <a href={this.state.editions[this.props.edition].bookIstaLink} target="_blank" style={{ color: "#000000", textDecoration: "underline" }} rel="noreferrer">Bookista</a>{this.state.editions[this.props.edition].editionDescription2}</p>
      )
    }
    else {
      return (
        <p className="intro">{this.state.editions[this.props.edition].editionDescription}</p>)
    }
  }
}

export default Publication;